<template>
	<div id="tabar">
		<!-- tabar -->
		<mt-tabbar v-model="select" fixed>
			<a  class="mint-tab-item" href="/">
				<div class="mint-tab-item-icon"><img  src="@/assets/shouye.png"></div> 
				<div class="mint-tab-item-label"> 首页 </div>
			</a>
		<!-- 	<mt-tab-item id="首页">
				<img slot="icon" v-show="!(select==='首页')" src="../assets/shouye.png">
				<img slot="icon" v-show="select==='首页'" src="@/assets/shouye-active.png">
				首页
			</mt-tab-item> -->
			<mt-tab-item id="医院简介">
				<img slot="icon" v-show="!(select==='医院简介')" src="@/assets/qiyejianjie.png">
				<img slot="icon" v-show="select==='医院简介'" src="@/assets/qiyejianjie-active.png">
				医院简介
			</mt-tab-item>
				<a  class="mint-tab-item" href="tel:028-62280120">
					<div class="mint-tab-item-icon"><img  src="@/assets/phone.png"></div> 
					<div class="mint-tab-item-label"> 拨号 </div>
				</a>
		<!-- 	<mt-tab-item herf="tel:028-62280120">
					<img slot="icon" src="@/assets/phone.png">
					拨号
			</mt-tab-item> -->
			
		</mt-tabbar>
	</div>
</template>
<style lang="scss" scoped>
	#tabar {
		overflow: hidden;
		.mint-tabbar.is-fixed{
			max-width: 750px;
			min-width: 320px;
			width: 100%;
			left: 50%;
			transform: translateX(-50%);
		}
		a{color: #000;}
		.mint-tabbar>.mint-tab-item.is-selected {
			background-color: #eaeaea;
			color: #109FC7;
		}
	}
</style>

<script>
	export default {
		name: "Tabar",
		data() {
			return {
				select: this.selected
			};
		},
		props: {
			selected: {
				type: String,
				default: '首页'
			}
		},
		
		methods:{
			callPhone (phoneNumber) {
			    window.location.href = 'tel://028-62280120'
			}
		},
		watch: {
			select: function(val, oldVal) {
				// 这里就可以通过 val 的值变更来确定去向
				switch (val) {
					case '首页':
						this.$router.push({
							name: 'Index'
						});
						break;
					case '医院简介':
						this.$router.push({
							name: 'Yyjj'
						});
						break;
					case '活动中心':
						this.$router.push({
							name: 'Activity',
						});
						break;
				}
			},
			$route(to, from) {
				// console.log(to.path);
				// 监听路由 
				if (to.path == '/home/index') {
					this.select = '首页';
				} else if (to.path == '/home/yyjj') {
					this.select = '医院简介';
				} 
				
				// console.log(this.select);
			}
		}
	};
</script>
